import MainLayout from '@/components/layout/MainLayout.vue';
import Pagination from 'laravel-vue-pagination';
import VueSlider from 'vue-slider-component';
import RegionJson from '@/assets/json/region.json';
import TwspNameJson from "@/assets/json/township.json";
import axios from "axios";
import 'vue-slider-component/theme/default.css';
import $ from "jquery";
import { mapGetters } from "vuex";
import { ConvertNumService } from '@/assets/js/convertNumberService.js';
import AdvancedLaravelVuePaginate from 'advanced-laravel-vue-paginate';
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css';
// import { fetchNotificationCount } from "@/services/common/notification-service";

const convertNumberService = new ConvertNumService();

export default {
    name: 'courseList',

    components: {
        MainLayout,
        Pagination,
        VueSlider,
        AdvancedLaravelVuePaginate
    },

    data() {
        return {
            pg_status: false,
            category: [],
            regionArr: RegionJson,
            twspNameJson: TwspNameJson,
            selectedTwspName: "",
            twspName: [],
            keyword: "",
            sortBy: "",
            courses: {},
            schools: {
                school_id: "",
                name: ""
            },
            teachers: {
                teacher_id: "",
                name: "",
            },
            filter: {
                category_id: "",
                teacher_id: [],
                school_id: [],
                course_name: "",
                orderBy: "",
                region: "",
                town: "",
            },
            lastPage: "",
            currentPage: ""
        };
    },

    created() {
        this.isTeacher = this.userType == "teacher" ? true : false;
    },

    computed: {
        ...mapGetters(["teacherId", "studentId", "userType"]),
    },

    methods: {
        getCourses(page = 1) {           
            axios.get("course/list?page=" + page)
            .then((response) => {
                this.courses = response.data;
                this.courses.data.forEach((course, index) => {
                    this.courses.data[index].rate = parseFloat(course.rate); 
                });
                this.courses.total = convertNumberService.convertEng2Mm(this.courses.total);
                this.lastPage = convertNumberService.convertEng2Mm(this.courses.last_page);
                this.currentPage = convertNumberService.convertEng2Mm(this.courses.current_page);
            })
            .catch((error) => {
                if (error.response.status == 401) {
                    this.$store.commit('logout');
                    window.location.replace('/');
                }
                console.log("Course List API error", error);
            });       
        },
        
        getTeachersForFilter() {
            axios.get("teacher/list/all")
                .then((response) => {
                    this.teachers = response.data;
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    console.log(error);
                });
        },

        getSchoolsForFilter() {
            axios.get("school/list/all")
                .then((response) => {
                    this.schools = response.data;
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    console.log(error);
                });
        },

        onChangeCategory(event) {
            this.filter.category_id = event.target.value;
        },

        onRegionChange(event) {
            var Value = event.target.value;
            this.filter.region = Value;
            this.selectedTwspName = "";
            if (Value == '') {
                this.twspName = null;
                this.filter.town = '';
            } else {
                this.twspName = this.changeTwspName(Value);
            }
        },

        changeTwspName(value, twspName) {
            twspName = this.twspNameJson[value];
            return twspName;
        },

        onChangeTwspName(event) {
            var Value = event.target.value;
            this.filter.town = Value;
        },

        resetCourseFilter() {
            this.filter = {
                category_id: '',
                teacher_id: [],
                course_name: "",
                orderBy: "",
                region: '',
                town: '',
            };
        },
        
        applyCourseFilter(page = 1) {            
            this.filter.orderBy = this.sortBy;
            axios.post("/course/list/filter?page=" + page, this.filter)
                .then((response) => {
                    this.pg_status = true;
                    this.courses = response.data;
                    this.courses.total = convertNumberService.convertEng2Mm(this.courses.total);
                    this.lastPage = convertNumberService.convertEng2Mm(this.courses.last_page);
                    this.currentPage = convertNumberService.convertEng2Mm(this.courses.current_page);
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    console.log("Course Filter Error", error);
                });
        },

        onChange(page = 1) {
            this.filter.orderBy = this.sortBy;
            axios.post("/course/list/filter?page=" + page, this.filter)
                .then((response) => {
                    this.pg_status = true;
                    this.courses = response.data;
                    this.courses.total = convertNumberService.convertEng2Mm(this.courses.total);
                    this.lastPage = convertNumberService.convertEng2Mm(this.courses.last_page);
                    this.currentPage = convertNumberService.convertEng2Mm(this.courses.current_page);
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    console.log("Course Filter Error", error);
                });
        },

        getCategoryForCourse() {
            axios.get("course/categories")
                .then((response) => {
                    this.category = response.data;
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    console.log(error);
                });
        },
    },

    mounted() {
        this.getCourses();        
        this.getCategoryForCourse();
        this.getTeachersForFilter();
        this.getSchoolsForFilter();
        // fetchNotificationCount();

        $(document).ready(function() {
            $("#myBtn").click(function(event) {
                event.preventDefault();
                $("html, body").animate({
                    scrollTop: 0
                });
                return false;
            });
            $(window).on('load', function() {
                // Animate loader off screen
                $(".se-pre-con").fadeOut("slow");
            });
        });
    }
}
